import { ProtectedRoute } from "@app/protected-route";
import { TwoFlowApp } from "@pages/two-flow-app/two-flow-app";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_layout/applications-two-flow/$applicationId",
)({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<ProtectedRoute
			requiredPermissions={[
				"see_all_logs",
				"create_and_score_application",
				"read_results",
			]}
		>
			<TwoFlowApp />
		</ProtectedRoute>
	);
}
